import React, { FC } from 'react';
import { Alert, Col, Row } from 'antd';

const NotAuthorized: FC = () => {
    return (
        <Row style={{ paddingBottom: 24 }}>
            <Col sm={0} md={6} xl={8}>
                {' '}
            </Col>
            <Col sm={24} md={12} xl={8}>
                <Alert message="Sin permisos suficientes" description='Para operar esta aplicación debes estar asignado.' type="warning" showIcon />
            </Col>
            <Col sm={0} md={6} xl={8}>
                {' '}
            </Col>
        </Row>
    );
};

export default NotAuthorized;
